import { Component, OnInit, Input } from '@angular/core';
import { CambioPiano } from '../../../models/fisso';
import { VulnerabilityType } from '../../../models/product';
import { textField } from './change-plan-customer-subscription';
import {AlgConsensoService} from '../../../services/alg-consenso.service';
@Component({
  selector: 'alg-change-plan-customer-subscription',
  templateUrl: './alg-change-plan-customer-subscription.component.html',
  styleUrls: ['./alg-change-plan-customer-subscription.component.scss']
})
export class AlgChangePlanCustomerSubscriptionComponent implements OnInit {
  @Input() changePlan: CambioPiano;
  @Input() isProductGasVulnerable: boolean;
  public vulnerabilityType: VulnerabilityType;
  public productName:string;

  constructor(
    private consensoService: AlgConsensoService
  ) { 
    this.consensoService.vulnerabilityType$.subscribe((value)=>{
      this.vulnerabilityType = value;
    })
  }

  public textField = textField

  ngOnInit() {
    this.productName = this.changePlan.NewProductName;
  }

}


// WEBPACK FOOTER //
// ./src/app/components/alg-change-plan/alg-change-plan-customer-subscription/alg-change-plan-customer-subscription.component.ts